import { type Dispatch, type SetStateAction, createContext, useContext } from 'react'

import { type CustomNode } from 'modules/job_catalog/components/JobCatalogTree/types'

interface TreeContextValue {
  onToggleExpand: (nodeId: string) => void
  onMultiSelectNode: (nodeId: string, checked: boolean) => void
  setNodes: Dispatch<SetStateAction<CustomNode[]>>
}

export const TreeContext = createContext<TreeContextValue | null>(null)

export const useTreeContext = () => {
  const context = useContext(TreeContext)

  if (!context) {
    throw new Error('useTreeContext must be used within TreeContext.Provider')
  }

  return context
}
